import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";

import { getReduxDevTools } from "../../util/store";

// Enable Redux DevTools Extension in dev environment
// Based on reference code in Redux Dev Tools GitHub docs:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/v0.4.2/examples/counter/store/configureStore.js#L7-L12
export default function configureStore(reducers, initialState) {
  const finalCreateStore = compose(applyMiddleware(thunkMiddleware), getReduxDevTools())(createStore);

  const store = finalCreateStore(reducers, initialState);
  // TODO: Implement reducer hot reloading based on reference code from docs

  return store;
}
